import { render, staticRenderFns } from "./LoadAllBrands.vue?vue&type=template&id=6740dcbf&scoped=true&"
import script from "./LoadAllBrands.vue?vue&type=script&lang=js&"
export * from "./LoadAllBrands.vue?vue&type=script&lang=js&"
import style0 from "./LoadAllBrands.vue?vue&type=style&index=0&id=6740dcbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740dcbf",
  null
  
)

export default component.exports